import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getUserById, resendVerificationEmail } from "../api/api";
import { MdEmail } from "react-icons/md";
// import "../RegistrationVarification/RegistrationVerification.css";
import "../CounsellorAllPages/CounsellorEmailVerification.css";
import bgImage from "../../assets/images/brown-background.jpg";
import Swal from "sweetalert2";

const CounsellorEmailVerification = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || null;
  const [currUser, setCurrUser] = useState(null);
  const [userData, setUserData] = useState(null);

  const getDataFromLocal = async () => {
    try {
      const userDatas = localStorage.getItem("currentUser");
      if (!userDatas) return;

      const parsedUserData = JSON.parse(userDatas);
      setCurrUser(parsedUserData);

      if (parsedUserData?._id) {
        const currentUser = await getUserById({ user_id: parsedUserData?._id });
        setUserData(currentUser.data);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    getDataFromLocal();
  }, []);

  const verification = async () => {
    try {
      const userDatas = localStorage.getItem("currentUser");
      if (!userDatas) return;
      const parsedUserData = JSON.parse(userDatas);
      const currentUser = await getUserById({
        user_id: parsedUserData?._id || parsedUserData?.id,
      });
      console.log("currentUser222", currentUser);
      if (currentUser?.data?.verification_status === "1") {
        navigate("/CounsellorImageUpload");
      } else {
        // alert("Please verify your email first, then click the Next button.");
        Swal.fire({
          icon: "warning",
          title: "Email Not Verified",
          text: "Please verify your email first, then click the Next button.",
        });
      }
    } catch (error) {
      console.error("Error in verification:", error);
    }
  };

  const ResendVerification = async () => {
    try {
      const userDatas = localStorage.getItem("currentUser");
      if (!userDatas) return;

      const parsedUserData = JSON.parse(userDatas);
      const response = await resendVerificationEmail(parsedUserData?._id);
      console.log("response333", response);

      //   alert(response?.message || "Verification email sent successfully.");
      Swal.fire({
        icon: "success",
        title: "Verification Email Sent",
        text: response?.message || "Verification email sent successfully.",
      });
    } catch (error) {
      console.error("Error in ResendVerification:", error);
      //   alert("Something went wrong. Please try again.");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again.",
      });
    }
  };

  return (
    <div
      className="CounsellorEmailVerification sechdr-toppding"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="containerall">
        <div className="counsellorEmailVerification-main">
          <div className="icon-container">
            <MdEmail className="email-icon" />
          </div>

          <div className="text-container">
            <p className="text">
              A verification email has been sent to{" "}
              <span className="email-highlight">{email || currUser?.email}</span>.
            </p>
            <p className="text">
              Please verify your account and then click "Next" once you're done.
            </p>
          </div>

          <button className="next-btn" onClick={verification}>
            Next
          </button>

          <div className="resend-container">
            <p className="text">Didn't receive the email?</p>
            {/* <button className="resend-btn" onClick={ResendVerification}> */}
            <div className="resend-btn" onClick={ResendVerification}>
              <p className="resendText">Resend Verification</p>
            </div>
            {/* </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CounsellorEmailVerification;
